import planModel from "src/models/plan"
import resourceModel from "src/models/resource"
import resourceTypeModel from "src/models/resourceType"
import eventModel from "src/models/event"
import eventTypeModel from "src/models/eventType"
import planTypeModel from "src/models/planType"
import constraintModel from "src/models/constraint"

const capitalizeFirstLetter = string =>
  string.charAt(0).toUpperCase() + string.slice(1)

export default function getWordByModelName(
  modelName,
  isGentive,
  isCapitalized,
) {
  let result = ``
  switch (modelName) {
    case planModel.name:
      result = isGentive ? `плана` : `план`
      break
    case resourceModel.name:
      result = isGentive ? `ресурса` : `ресурс`
      break
    case resourceTypeModel.name:
      result = isGentive ? `типа ресурса` : `тип ресурса`
      break
    case eventModel.name:
      result = isGentive ? `события` : `событие`
      break
    case eventTypeModel.name:
      result = isGentive ? `типа события` : `тип события`
      break
    case planTypeModel.name:
      result = isGentive ? `типа плана` : `тип плана`
      break
    case constraintModel().name:
      result = isGentive ? `ограничения плана` : `ограничение плана`
      break
    default:
  }

  return isCapitalized ? capitalizeFirstLetter(result) : result
}
